module.exports = __webpack_public_path__ + "img/Weapon_46.cdc9aff4.png";